/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthorisePaymentResponse
 */
export interface AuthorisePaymentResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AuthorisePaymentResponse
     */
    isPaymentResultAvailable: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthorisePaymentResponse
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorisePaymentResponse
     */
    action?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorisePaymentResponse
     */
    returnUrl?: string | null;
}

/**
 * Check if a given object implements the AuthorisePaymentResponse interface.
 */
export function instanceOfAuthorisePaymentResponse(value: object): value is AuthorisePaymentResponse {
    if (!('isPaymentResultAvailable' in value) || value['isPaymentResultAvailable'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    return true;
}

export function AuthorisePaymentResponseFromJSON(json: any): AuthorisePaymentResponse {
    return AuthorisePaymentResponseFromJSONTyped(json, false);
}

export function AuthorisePaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorisePaymentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isPaymentResultAvailable': json['isPaymentResultAvailable'],
        'paymentReference': json['paymentReference'],
        'action': json['action'] === undefined ? undefined : json['action'] === null ? null : json['action'],
        'returnUrl': json['returnUrl'] === undefined ? undefined : json['returnUrl'] === null ? null : json['returnUrl'],
    };
}

export function AuthorisePaymentResponseToJSON(json: any): AuthorisePaymentResponse {
    return AuthorisePaymentResponseToJSONTyped(json, false);
}

export function AuthorisePaymentResponseToJSONTyped(value?: AuthorisePaymentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isPaymentResultAvailable': value['isPaymentResultAvailable'],
        'paymentReference': value['paymentReference'],
        'action': value['action'],
        'returnUrl': value['returnUrl'],
    };
}

